export default __webpack_public_path__ + "static/media/Levitate D8.3 Application of the Decision Support Tool on Selected Use Cases.fea331f7.pdf";